import { render, staticRenderFns } from "./TakeoffPassengersDataForm.vue?vue&type=template&id=e0234c7a&"
import script from "./TakeoffPassengersDataForm.vue?vue&type=script&lang=js&"
export * from "./TakeoffPassengersDataForm.vue?vue&type=script&lang=js&"
import style0 from "./TakeoffPassengersDataForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0234c7a')) {
      api.createRecord('e0234c7a', component.options)
    } else {
      api.reload('e0234c7a', component.options)
    }
    module.hot.accept("./TakeoffPassengersDataForm.vue?vue&type=template&id=e0234c7a&", function () {
      api.rerender('e0234c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/dialog/data/TakeoffPassengersDataForm.vue"
export default component.exports